<template>
    <transition name="toggleContentComponent">
        <article class="fullscreenVideo" v-if="ready"
            :class="{ 'fullscreenVideo--videopaused': isVideoPaused, 'fullscreenVideo--maximized': properties.maximized }">
            <video ref="video" v-if="properties.video.src" :autoplay="properties.autoplay"
                :controls="properties.controls" :mute="properties.mute" :loop="properties.loop" :poster="posterUrl"
                @playing="isVideoPaused = false" @pause="isVideoPaused = true;" type="video/mp4" playsinline
                webkit-playsinline crossorigin @click="toggleVideo">
                <source :src="videoUrl">
            </video>

            <button class="fullscreenVideo__close" :style="{right:getMaximizedSizeAndOffset.left}" @click="closeComponent">
            </button>
        </article>
    </transition>
</template>

<script>


export default {
    props: ["properties", "pageData", "slug"],
    data() {
        return {
            ready: false,
            isVideoPaused: true,
            mutedAudioManager: false
        }
    },
    mounted() {
        this.ready = true;
        this.muteAudioManager();
    },
    methods: {
        toggleVideo() {
            const video = this.$refs.video;
            if (!video) return;

            if (video.paused) {
                video.play();
            } else {
                video.pause();
            }

        },
        muteAudioManager() {
            if (!this.$store.getters.getIsMuted) {
                this.mutedAudioManager = true;
                let event = new CustomEvent('muteAudio');
                window.dispatchEvent(event);
            }
        },
        unmuteAudioManager() {
            if (this.mutedAudioManager) {
                let event = new CustomEvent('unmuteAudio');
                window.dispatchEvent(event);
            }
        },
        closeComponent() {
            this.$emit("closeComponent", this.slug)
        }
    },
    unmounted() {
        this.unmuteAudioManager();
    },
    computed: {
        videoUrl() {
            return app.api.Utils.getMediaPath(this.properties.video.src)
        },
        posterUrl() {
            return app.api.Utils.getMediaPath(this.properties.poster.src)
        },
        getMaximizedSizeAndOffset() {
            return this.$store.getters.getMaximizedSizeAndOffsetValue;
        },
    }
};
</script>

<style lang="scss">
.fullscreenVideo {
    height: 76%;
    display: flex;
    justify-content: center;
    align-items: center;

    &>video {
        height: 100%;
    }



    &::after {
        content: none;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translateX(-50%) translateY(-50%);
        width: 60px;
        height: 60px;
        pointer-events: none;
        background-image: url(@/assets/img/ui/play.svg);
        background-repeat: no-repeat;
        background-size: 80%;
        background-position: center;
        z-index: 3;
    }

    &::before {
        content: none;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translateX(-50%) translateY(-50%);
        width: 120px;
        height: 120px;
        pointer-events: none;
        border-radius: 50%;
        background: var(--secondary-color);
        opacity: 0.3;
        z-index: 3;
    }

    &--videopaused {
        video {
            cursor: pointer;
        }

        &::after,
        &::before {
            content: '';
        }
    }

    &--maximized {
        width: 2160px;
        height: 100.1%;

        video {
            object-fit: cover;
            height: 100%;
        }

        .fullscreenVideo__close {
            position: fixed;
            margin-right: 20px;
            left: auto;
            top: 20px;
            border-radius: 50%;
            height: 40px;
            width: 40px;
        }
    }
}


.fullscreenVideo__close {
    position: absolute;
    left: 100%;
    top: 0;
    height: 60px;
    width: 60px;
    background: var(--main-color);
    background-image: url(@/assets/img/ui/close.svg);
    background-size: 16px;
    background-position: center;
    background-repeat: no-repeat;
}
</style>